<template>
  <flow-part :id="$options.name">
    <template #heading>
      <h2>Weet je jouw verbruik?</h2>
    </template>
    <template #content>
      <div class="input-group vertical">
        <BigRadioInput id="estimation-help-no" v-model="radioOption" :value="true" title="Ja, ik weet mijn verbruik"
          name="estimation-help-radio" @click="scrollIfPrefilled(radioOption, true)" />

        <BigRadioInput id="estimation-help-yes" v-model="radioOption" :value="false" title="Nee, help mij inschatten"
          name="estimation-help-radio" @click="scrollIfPrefilled(radioOption, false)" />
      </div>

      <div class="wizard-tip card component-spacing-top" v-if="comparisonStore.currentProvider && !['unknown', 'no-provider', 'moving'].includes(comparisonStore.currentProvider )">
        <strong>Verlengaanbod ontvangen van {{ comparisonStore.currentProvider }}?</strong>
        <p>Kies dan <span class="light-bold">'Ja, ik weet mijn verbruik'</span>. Vul in de volgende stap hetzelfde verbruik in dat {{  comparisonStore.currentProvider }} voor je verlengaanbod heeft gebruikt. </p> 
        <p>Je kunt dan eenvoudig de jaarprijzen met elkaar vergelijken. Zo weet je direct of het interessant is om over te stappen.</p>
      </div>

      <step-info-toggle title="Verbruik niet bij de hand?">
        <template #content>
          Heb je je energierekening of jaarverbruik niet bij de hand? Geen probleem, dan maken we een realistische inschatting voor jouw situatie.
          <br>
          <br>
          Je kunt nog steeds vergelijken en overstappen. Je betaalt altijd alleen voor wat je daadwerkelijk verbruikt.
        </template>
      </step-info-toggle>
    </template>
  </flow-part>
</template>

<script>
import Icon from '../../../../vue-elements/icon/Icon.vue';
import WizardStepMixin from '../../../../vue-elements/wizard/lib/WizardStepMixin.js';
import StepInfoToggle from '../StepInfoToggle.vue';
import FlowPart from '../FlowPart.vue';
import { useEnergyComparisonStore } from '../../stores/energyComparison.js';
import BigRadioInput from '../../../../vue-elements/input/BigRadioInput.vue';

export default {
  name: 'EstimationHelpStep',
  mixins: [WizardStepMixin()],
  components: {
    BigRadioInput,
    FlowPart,
    Icon,
    StepInfoToggle,
  },
  setup() {
    const comparisonStore = useEnergyComparisonStore();

    return {
      comparisonStore,
    };
  },
  data() {
    return {
      radioOption: null,
    };
  },
  watch: {
    radioOption(value) {
      if (value !== null) {
        // If the selected step is already loaded, dont trigger nextstep
        if (this.comparisonStore.filters.manualInputStep !== value) {
          this.comparisonStore.filters.manualInputStep = value;

          this.logAnalyticsEvent('compare-energy.wizard-step-complete', {
            step: this.$options.name,
            value,
          });

          this.nextStep();
        }
      }
    },
  },
  created() {
    this.radioOption = this.comparisonStore.filters.manualInputStep;
  },
  methods: {
    validate() {
      this.status = this.comparisonStore.filters.manualInputStep !== null && (this.radioOption !== null) ? 'complete' : 'invalid';
    },
  },
};
</script>
